"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoTileLabel = void 0;
var PEER_NAME_PLACEHOLDER = "peerName";
var labelMap = new Map([[[true, "screen"].toString(), "Your Screen"], [[true, "regular"].toString(), "You (".concat(PEER_NAME_PLACEHOLDER, ")")], [[false, "screen"].toString(), "".concat(PEER_NAME_PLACEHOLDER, "'s Screen")], [[false, "regular"].toString(), PEER_NAME_PLACEHOLDER], [[true, undefined].toString(), "You (".concat(PEER_NAME_PLACEHOLDER, ")")], [[false, undefined].toString(), "".concat(PEER_NAME_PLACEHOLDER)]]);
var getVideoTileLabel = function getVideoTileLabel(_ref) {
  var peerName = _ref.peerName,
    isLocal = _ref.isLocal,
    track = _ref.track;
  var isPeerPresent = peerName !== undefined;
  if (!isPeerPresent || !track) {
    // for peers with only audio track
    return isPeerPresent ? labelMap.get([isLocal, undefined].toString()).replace(PEER_NAME_PLACEHOLDER, peerName) : "";
  }
  var isLocallyMuted = track.volume === 0;
  // Map [isLocal, videoSource] to the label to be displayed.
  var label = labelMap.get([isLocal, track.source].toString());
  if (label) {
    label = label.replace(PEER_NAME_PLACEHOLDER, peerName);
  } else {
    label = "".concat(peerName, " ").concat(track.source);
  }
  label = "".concat(label).concat(track.degraded ? "(Degraded)" : "");
  return "".concat(label).concat(isLocallyMuted ? " (Muted for you)" : "");
};
exports.getVideoTileLabel = getVideoTileLabel;